export default "__VITE_ASSET__DAJl1uVx__"